export function BuyerGuide() {
  return (
    <section className="py-16 lg:py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4">
            How to Shop Smart in the $20k-$30k Range
          </h2>
          <p className="text-lg text-slate-600">
            This is where most people overpay. Here's how to avoid the traps and get the best value for your money.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          <div className="bg-slate-50 p-8 rounded-xl">
            <div className="w-14 h-14 bg-slate-900 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-calendar-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">Age Matters More Than Mileage</h3>
            <p className="text-slate-600 mb-4">
              A 2020 with 60k highway miles beats a 2022 with 30k city miles every time. Highway miles are easy miles. 
              Stop-and-go traffic is what kills cars. We'd rather sell you a well-driven car than a barely-driven one 
              that sat in a garage rusting from the inside.
            </p>
          </div>

          <div className="bg-slate-50 p-8 rounded-xl">
            <div className="w-14 h-14 bg-slate-900 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-shield-check-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">Avoid the "Luxury Trap"</h3>
            <p className="text-slate-600 mb-4">
              A $28k used BMW might seem like a steal compared to a $28k used Toyota. Until you need to replace the 
              water pump and it costs $2,000 instead of $400. Luxury cars depreciate fast for a reason — they're 
              expensive to maintain. Buy what you can afford to fix.
            </p>
          </div>

          <div className="bg-slate-50 p-8 rounded-xl">
            <div className="w-14 h-14 bg-slate-900 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-file-list-3-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">Service History Is Everything</h3>
            <p className="text-slate-600 mb-4">
              A car with a clean Carfax but no service records is a gamble. We want to see oil changes, tire rotations, 
              brake jobs — proof that someone actually cared. If the previous owner kept receipts, they probably kept 
              the car in good shape. If they didn't, assume the worst.
            </p>
          </div>

          <div className="bg-slate-50 p-8 rounded-xl">
            <div className="w-14 h-14 bg-slate-900 rounded-lg flex items-center justify-center mb-4">
              <i className="ri-money-dollar-circle-line text-2xl text-white"></i>
            </div>
            <h3 className="text-xl font-bold text-slate-900 mb-3">Don't Overbuy on Features</h3>
            <p className="text-slate-600 mb-4">
              Do you really need the panoramic sunroof, heated steering wheel, and 19-inch wheels? Or do you just 
              need a reliable car that gets you to work? Every extra feature is another thing that can break. 
              Sometimes boring is better.
            </p>
          </div>
        </div>

        <div className="mt-12 max-w-3xl mx-auto bg-teal-50 border-l-4 border-teal-500 p-6 rounded-r-lg">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 bg-teal-500 rounded-lg flex items-center justify-center flex-shrink-0">
              <i className="ri-lightbulb-line text-xl text-white"></i>
            </div>
            <div>
              <h4 className="font-bold text-slate-900 mb-2">The Best Value Play</h4>
              <p className="text-slate-700">
                Buy a 2-3 year old Toyota, Honda, or Mazda with 30k-50k miles. Let someone else eat the depreciation, 
                then enjoy 10+ years of reliable driving. It's not sexy, but it's smart. And you'll still have money 
                left over for the fun stuff — like actually going places in your car.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
